import classes from './MainLoader.module.css';

const Loader = () => {
    return (
        <div className={classes.loader}>
            <div className={classes['loader-element']}></div>
        </div>
    );
};

export default Loader;
